import * as React from "react"
const SvgAnalytics = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8.62 21.284a.97.97 0 0 0 .713.287.97.97 0 0 0 .713-.287.97.97 0 0 0 .287-.713v-9a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288.97.97 0 0 0-.712.288.97.97 0 0 0-.288.712v9q0 .425.288.713Zm11.38.287a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713v-9q0-.424.288-.712A.97.97 0 0 1 20 10.57q.424 0 .712.288.288.289.288.712v9a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287Zm-5.333 0a.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713v-5a.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288q.424 0 .712.288t.288.712v5a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287M4 21.571a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 20.57v-5q0-.424.288-.712A.97.97 0 0 1 4 14.57a.97.97 0 0 1 .713.288q.287.289.287.712v5a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287Zm16.8-17.6a1 1 0 0 1-.2 1.4l-5.333 4a1 1 0 0 1-1.2 0l-4.734-3.55L4.6 9.371a1 1 0 1 1-1.2-1.6l5.333-4a1 1 0 0 1 1.2 0l4.734 3.55 4.733-3.55a1 1 0 0 1 1.4.2" />
  </svg>
)
export default SvgAnalytics
